import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '../Store';

export const commonProvince = (state: AppState) => state;

export const commonSelector = createSelector(commonProvince, ({ common }) => common);
